import React, { createContext, useCallback, useMemo, useReducer } from 'react';
import authReducer from './reducers/auth';
import authInitialState from './initialStates/auth';

export const GlobalContext = createContext({});

const Provider = ({ children }) => {
  const [authState, authDispatch] = useReducer(authReducer, authInitialState)
  const can = useCallback((permission) => {
    const permissions = authState.permissions || [];
    return permissions.includes('*') || permissions.includes(permission);
  }, [authState.permissions]);
  const value = useMemo(
    () => ({ authState, authDispatch, can }),
    [authState, can],
  );

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  )
}

export default Provider;
